export default __webpack_public_path__ + "static/media/18.ab1571dd.png";